module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    attrs: {
      "id": "a04_maps"
    }
  }, [_c('p', {
    staticClass: "map"
  }, [_vm._v("THE MAPS")]), _vm._v(" "), _c('p', {
    staticClass: "map1"
  }, [_vm._v("Large-scale versions of the maps located at the back can be downloaded from the book’s page on the publishers’ websites.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-47b681eb","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/04_maps.vue
// module id = 66
// module chunks = 0